// Apologies to those who venture here, Jeremy did Quite a lot of R&D and it shows

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let
  mm = gsap.matchMedia(),
  breakPoint = 700;

mm.add(
  {
    // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
    isDesktop: `(min-width: ${breakPoint}px)`,
    isMobile: `(max-width: ${breakPoint - 1}px)`,
    reduceMotion: "(prefers-reduced-motion: reduce)",
  },
  (context) => {
    // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
    let { isDesktop, isMobile, reduceMotion } = context.conditions;

    //  Don't run any of this on a page that's not a fancy landing
    if (!document.querySelector('body').classList.contains('page-fancy-landing')) {
      return;
    }

    // Create the scrolltrigger for inView
    ScrollTrigger.create({
      start: 0,
      end: 'max',
      onUpdate: checkInView,
    });

    function checkInView() {
      checkShowreelVisible();

      let features = getFeatures();
      checkFeaturesVisible(features);
      
      let logos = getLogos();
      checkLogosVisible(logos);

      let caseStudies = getCaseStudies();
      checkCaseStudiesVisible(caseStudies);
    }

    // Set bg colours
    gsap.set(".ss-hero", { background: "transparent" });

    /**
     * Hero
     */
    // Line 1
    gsap.from(".ss-hero-heading__line:first-child", {
      scrollTrigger: {
        trigger: ".ss-hero"
      },
      y: "0.5em",
      autoAlpha: 0,
      duration: 1,
    });

    // Line 2
    gsap.from(".ss-hero-heading__line:last-child", {
      scrollTrigger: {
        trigger: ".ss-hero"
      },
      y: "0.5em",
      autoAlpha: 0,
      duration: 1,
      delay: 0.1,
    });

    // Whole heading fade out with scroll
    let herotl = gsap.timeline({
      scrollTrigger: {
        trigger: ".ss-hero",
        start: "top 100",
        end: "bottom 50%",
        scrub: 1,
      },
    });

    herotl
      .addLabel("start")
      .to(".fancy-landing", { background: "#ede9df" })
      .to(".ss-hero-heading", { autoAlpha: 0, y: "-1em" })
      .to(".ss-hero", { background: "transparent" }, "-=50%")
      .to(".ss-intro__graphic", { autoAlpha: 1, y: "-10%" }, "<");

    /**
     * Intro
     */
    gsap.set(".ss-intro", {
      background: "transparent",
      marginTop: "-40vh",
    });
    gsap.set(".ss-intro__graphic", {
      autoAlpha: 0,
      y: "-10%",
    });
    gsap.set(".ss-intro__copy-para", {
      autoAlpha: 0,
      y: "50%",
      top: "0",
      position: "absolute",
    });

    let introtl = gsap.timeline({
      scrollTrigger: {
        trigger: ".ss-intro",
        start: "top 100",
        end: "bottom top",
        scrub: 1,
        pin: true,
      },
    });

    let introParagraphs = document.querySelectorAll(".ss-intro__copy-para");

    introtl
      .addLabel("first-para")
      .to(
        ".ss-intro__copy-para:nth-child(1)",
        { autoAlpha: 1, y: "-50%", duration: 2 }, "<50%"
      );

    for (let i = 0; i < introParagraphs.length - 1; i++) {
      const para = introParagraphs[i];

      introtl
        .addLabel("para-" + i)
        .to(".ss-intro__copy-para:nth-child(" + (i + 1) + ")", {
          autoAlpha: 0,
          y: "-100%",
          duration: 2
        })
        .to(
          ".ss-intro__copy-para:nth-child(" + (i + 2) + ")",
          { autoAlpha: 1, y: "-50%", duration: 2 },
          "<50%"
      );
      
    }
    
    introtl
      .addLabel("last-para")
      .to(
      ".ss-intro__copy-para:last-child",
      { autoAlpha: 0, y: "-100%", duration: 3 },
    );


    let introexittl = gsap.timeline({
      scrollTrigger: {
        trigger: ".ss-intro",
        start: "bottom 75%",
        end: "bottom 50%",
        scrub: 1,
      },
    });

    introexittl.addLabel('intro-exit')
      .to(".ss-intro", { autoAlpha: 0 })
      .to(".fancy-landing", { background: "#000" })

    /**
     * Showreel
     */
    let showreel = document.querySelector(".ss-showreel .Showreel");
    let showreelImages = document.querySelector(".ss-showreel .Showreel-images");
    let showreelContent = document.querySelector(".ss-showreel .Showreel-content");

    gsap.set(showreel, {
      background: "transparent",
      marginTop: "-10vh"
    });
    

    function checkShowreelVisible() {
      if (ScrollTrigger.isInViewport(".ss-showreel", 0.5)) {
        showreel.classList.remove('hidden');
        showreelContent.querySelector('.LayeredBox-copy').dataset.scroll = "in";
      }
      else {
        showreel.classList.add('hidden');
        showreelContent.querySelector('.LayeredBox-copy').dataset.scroll = "out";
      }
    }

    /**
     * Big heading
     */
    let bigHeadingstl = gsap.timeline({
      scrollTrigger: {
        trigger: ".ss-big-heading",
        start: "top 50%",
        end: "bottom 50%",
        scrub: 2
      }
    });

    gsap.set(".ss-big-heading__line:first-child", { x: "-25%" });
    gsap.set(".ss-big-heading__line:last-child", { x: "25%" });

    bigHeadingstl.addLabel('slide')
      .to(".ss-big-heading__line:first-child", { x: "25%" })
      .to(".ss-big-heading__line:last-child", { x: "-25%" }, "<")
    
    
    /**
     * Features
     */
    gsap.set(".ss-feature__content", { autoAlpha: 0, x: "-25%", position: "sticky", top: 300 });
    gsap.set(".ss-feature__img-sm-wrap .ss-feature__img", { autoAlpha: 0, y: isDesktop ? "10em" : "5em" });
    gsap.set(".ss-feature__img-lg-wrap .ss-feature__img", { autoAlpha: 0, y: isDesktop ? "10em" : "5em" });

    function getFeatures() {
      return document.querySelectorAll('.ss-feature');
    }

    function checkFeaturesVisible(features) {
      for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        const content = feature.querySelector('.ss-feature__content');
        const imageSm = feature.querySelector('.ss-feature__img-sm-wrap .ss-feature__img');
        const imageLg = feature.querySelector('.ss-feature__img-lg-wrap .ss-feature__img');

        if (ScrollTrigger.isInViewport(feature, 0.25) && !feature.classList.contains('visible')) {
          feature.classList.add('visible');
          gsap.to(content, { autoAlpha: 1, x: "0%", duration: 0.5 });
          gsap.to(imageSm, { autoAlpha: 1, y: isDesktop ? "7em" : "3em", duration: 1.25 });
          gsap.to(imageLg, { autoAlpha: 1, y: isDesktop ? "7em" : "3em", duration: 1.5 });
        }
      }
    }

    const features = getFeatures();
    let featuresTimelines = [];

    for (let i = 0; i < features.length; i++) {
      const feature = features[i];
      const imageSm = feature.querySelector('.ss-feature__img-sm-wrap');
      const imageLg = feature.querySelector('.ss-feature__img-lg-wrap');

      featuresTimelines[i] = gsap.timeline({
        scrollTrigger: {
          trigger: feature,
          start: "top bottom",
          end: "bottom 50%",
          scrub: 2
        }
      });

      featuresTimelines[i].addLabel('parallax')
      .to(imageSm, { y: isDesktop ? "-20em" : "-5em" })
      .to(imageLg, { y: isDesktop ? "-10em" : "-2.5em" }, "<")
    }

    /** 
     * Logos
     */

    function getLogos() {
      return document.querySelectorAll('.ss-logos .Logos img');
    }

    gsap.set(".ss-logos .Logos img", { autoAlpha: 0, scale: 0.5 });

    function checkLogosVisible(logos) {
      for (let i = 0; i < logos.length; i++) {
        const logo = logos[i];

        if (ScrollTrigger.isInViewport(logo, 0.5) && !logo.classList.contains('visible')) {
          logo.classList.add('visible');
          gsap.to(logo, { autoAlpha: 1, scale: 1, duration: 0.25, delay: gsap.utils.random(0, 0.5) });
        }
      }
    }

    /**
     * Case studies
     */

    function getCaseStudies() {
      return document.querySelectorAll('.CaseStudyTiles-item');
    }

    gsap.set(".CaseStudyTiles-item", { autoAlpha: 0, y: "2em" });

    function checkCaseStudiesVisible(caseStudies) {
      for (let i = 0; i < caseStudies.length; i++) {
        const caseStudy = caseStudies[i];

        if (ScrollTrigger.isInViewport(caseStudy, 0.25) && !caseStudy.classList.contains('visible')) {
          caseStudy.classList.add('visible');
          gsap.to(caseStudy, { autoAlpha: 1, y: 0, duration: 0.5, delay: gsap.utils.random(0, 0.25) });
        }
      }
    }

    checkInView();


    return () => {
      // optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
      // it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
    };
  }
);